import { createAction } from '@reduxjs/toolkit';
import { type ExperimentsBag } from '@wix/wix-experiments';

// Loading experiments is controlled in ExperimentsProvider
export const loadExperiments = createAction('LOAD_EXPERIMENTS', (experiments: ExperimentsBag) => {
  return {
    payload: experiments,
  };
});
